/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} Machine_Translation_NameInputs */

const en_machine_translation_name = /** @type {(inputs: Machine_Translation_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` MT | ${i?.language}`)
};

const fr_machine_translation_name = /** @type {(inputs: Machine_Translation_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` MT | ${i?.language}`)
};

const de_machine_translation_name = /** @type {(inputs: Machine_Translation_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`MT | ${i?.language}`)
};

const it_machine_translation_name = /** @type {(inputs: Machine_Translation_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`MT | ${i?.language}`)
};

const ru_machine_translation_name = /** @type {(inputs: Machine_Translation_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`МТ | ${i?.language}`)
};

const es_machine_translation_name = /** @type {(inputs: Machine_Translation_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`MT | ${i?.language}`)
};

const zh_cn2_machine_translation_name = /** @type {(inputs: Machine_Translation_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`MT | ${i?.language}`)
};

const ja_machine_translation_name = /** @type {(inputs: Machine_Translation_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`MT | ${i?.language}`)
};

const pt_pt2_machine_translation_name = /** @type {(inputs: Machine_Translation_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`MT | ${i?.language}`)
};

/**
* | output |
* | --- |
* | "MT \| {language}" |
*
* @param {Machine_Translation_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const machine_translation_name = /** @type {((inputs: Machine_Translation_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Machine_Translation_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_machine_translation_name(inputs)
	if (locale === "de") return de_machine_translation_name(inputs)
	if (locale === "it") return it_machine_translation_name(inputs)
	if (locale === "ru") return ru_machine_translation_name(inputs)
	if (locale === "es") return es_machine_translation_name(inputs)
	if (locale === "zh-CN") return zh_cn2_machine_translation_name(inputs)
	if (locale === "ja") return ja_machine_translation_name(inputs)
	if (locale === "hi") return /** @type {LocalizedString} */ ("एमटी | __पीएच_0__")
	if (locale === "pt-PT") return pt_pt2_machine_translation_name(inputs)
	return en_machine_translation_name(inputs)
});